
import { Options, Vue } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'

@Options({
  name: 'SaveConditionDialog',
  emits: ['update:modelValue', 'confirm'],
})
export default class SaveConditionDialog extends Vue {
  @Prop({ type: Boolean, default: false }) readonly modelValue!: boolean
  @Prop({ type: Boolean, default: false }) readonly loading!: boolean
  @Prop({ type: Array, default: () => [] }) readonly existingNames!: string[]

  inputName = ''

  get isDuplicate(): boolean {
    const trimmed = this.inputName.trim().toLowerCase()
    return !!trimmed && this.existingNames.some((n) => n.trim().toLowerCase() === trimmed)
  }

  @Watch('modelValue')
  onVisibilityChange(val: boolean) {
    if (!val) this.inputName = ''
  }

  handleConfirm() {
    if (!this.inputName.trim() || this.isDuplicate || this.loading) return
    this.$emit('confirm', this.inputName.trim())
  }
}
